var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g(_vm._b({directives:[{name:"waypoint",rawName:"v-waypoint",value:({
    active: !_vm.done && _vm.animationPaused,
    callback: _vm.onWaypoint,
    options: _vm.intersectionOptions,
  }),expression:"{\n    active: !done && animationPaused,\n    callback: onWaypoint,\n    options: intersectionOptions,\n  }"}]},'span',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.tweenedNumber))])
}
var staticRenderFns = []

export { render, staticRenderFns }